module.exports = __webpack_public_path__ + "static/img/img_logo.a69d979d.png";